import React, { useState, useEffect } from 'react'
import { GET_LIST, useClient } from '@peracto/client'
import { StyledCheckbox } from '@peracto/peracto-ui'

const UserGroupRestrictionsList = props => {
    const { settings, setSettings } = props
    const [customerGroups, setCustomerGroups] = useState([])

    const { client } = useClient()

    const { flattenedContentAccessRestrictions } = settings

    const fetchUserGroups = async () => {
        const { data } = await client(GET_LIST, 'user-groups', {
            id: 'user-groups',
            pagination: { perPage: 10000 },
        })

        const values = data.map(val => ({
            label: val.name,
            value: val.identifier,
        }))

        setCustomerGroups(values)

        return values
    }

    useEffect(() => {
        fetchUserGroups()
    }, [])

    return customerGroups?.length > 0 ? (
        <table className="table table-sm" data-testid="related-products-list">
            <colgroup>
                <col width="75%" />
                <col width="25%" />
            </colgroup>

            <thead>
                <tr>
                    <th>User Group</th>
                    <th className="!text-right">Has Access</th>
                </tr>
            </thead>

            <tbody>
                {customerGroups.map((item, index) => (
                    <tr key={`account-${index}`} data-id={`account-${index}`}>
                        <td data-testid={`account-${index}-number`}>{item.label}</td>
                        <td className="!text-right">
                            <StyledCheckbox
                                checked={!flattenedContentAccessRestrictions?.includes(item.value)}
                                onChange={e => {
                                    if (e.target.checked) {
                                        const filteredGroups = flattenedContentAccessRestrictions?.filter(
                                            group => group !== item.value
                                        )
                                        setSettings({
                                            ...settings,
                                            flattenedContentAccessRestrictions: filteredGroups,
                                        })
                                    } else {
                                        setSettings({
                                            ...settings,
                                            flattenedContentAccessRestrictions: [
                                                ...flattenedContentAccessRestrictions,
                                                item.value,
                                            ],
                                        })
                                    }
                                }}
                                data-testid={`account-${index}-checkbox`}
                                rightAlign={true}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    ) : (
        <p className="!text-center !my-4" data-testid="no-restrictions">
            No customer groups
        </p>
    )
}
export default UserGroupRestrictionsList
